import type { DataTableColumn } from '@/components/custom/erp/data-table-v2';

export const invoicePaymentAllocationColumns = (): DataTableColumn[] => [
  {
    field: 'voucherNumber',
    headerName: 'Số phiếu chi',
    width: 110
  },
  {
    field: 'voucherDate',
    headerName: 'Ngày phiếu chi',
    width: 120
  },
  {
    field: 'supplierCode',
    headerName: 'Mã nhà cung cấp',
    width: 120
  },
  {
    field: 'supplierName',
    headerName: 'Tên nhà cung cấp',
    width: 300
  },
  {
    field: 'currency',
    headerName: 'Ngoại tệ',
    width: 80
  },
  {
    field: 'account',
    headerName: 'Tài khoản',
    width: 100
  },
  {
    field: 'amount',
    headerName: 'Tiền chi',
    width: 100,
    type: 'number'
  },
  {
    field: 'allocatedAmount',
    headerName: 'Đã phân bổ',
    width: 100,
    type: 'number'
  },
  {
    field: 'document',
    headerName: 'Chứng từ',
    width: 100
  }
];

export const invoiceDetailColumns: DataTableColumn[] = [
  {
    field: '...',
    headerName: '...',
    width: 30
  },
  {
    field: 'id',
    headerName: 'Stt',
    width: 30
  },
  {
    field: 'documentNumber',
    headerName: 'Số chứng từ',
    width: 100
  },
  {
    field: 'documentDate',
    headerName: 'Ngày chứng từ',
    width: 100
  },
  {
    field: 'invoiceNumber',
    headerName: 'Số hóa đơn',
    width: 100
  },
  {
    field: 'invoiceDate',
    headerName: 'Ngày hóa đơn',
    width: 100
  },
  {
    field: 'totalAmount',
    headerName: 'Tổng tiền',
    width: 100,
    type: 'number'
  },
  {
    field: 'allocatedAmount',
    headerName: 'Đã phân bổ',
    width: 100,
    type: 'number'
  },
  {
    field: 'voucherAllocation',
    headerName: 'P/bổ trên pchi',
    width: 100,
    type: 'number'
  },
  {
    field: 'allocation',
    headerName: 'Phân bổ',
    width: 100,
    type: 'number'
  },
  {
    field: 'remainingAmount',
    headerName: 'Còn lại',
    width: 100,
    type: 'number'
  },
  {
    field: 'isFullyPaid',
    headerName: 'Tất toán',
    width: 100
  },
  {
    field: 'paymentDueDate',
    headerName: 'Hạn thanh toán',
    width: 120
  },
  {
    field: 'paymentDate',
    headerName: 'Ngày thanh toán',
    width: 120
  },
  {
    field: 'document',
    headerName: 'Chứng từ',
    width: 100
  }
];
